import { Content } from './voice.styled';

export const Voice = ({ voice, value, change }) => {
  if (!voice || voice.phones.length < 2) {
    return null;
  }
  const itemsEl = voice.phones.map((el, idx) => {
    return (
      <option key={idx} value={el}>
        {el}
      </option>
    );
  });

  return (
    <Content>
      <label htmlFor='phoneSelect'>Выбрать номер</label>
      <select onChange={change} value={value}>
        {itemsEl}
      </select>
    </Content>
  );
};
